import {
  UserPermissionDto,
  useUsersAuthzAPIAdminPermissionsReadGetPermissionsOfUser,
  useUsersAuthzAPIAdminPermissionsWriteResetUserPermissions,
  useUsersAuthzAPIPermissionsCatalogGetPermissionsCatalog,
} from '@mi-front/api-clients';
import { User } from '@mi-front/core';
import { useQueryClient } from '@tanstack/react-query';
import { ActionPermissionsView, PermissionItemComponentProps } from './ActionPermissionsView';
import { UserPermissionItem } from './UserPermissionItem';

interface Props {
  readonly user: User;
}

export function UserActionPermissionsView(p: Props) {
  const queryClient = useQueryClient();
  const { user } = p;

  // Fetch permissions catalog
  const permissionsCatalogQuery = useUsersAuthzAPIPermissionsCatalogGetPermissionsCatalog();

  // Fetch current user permissions
  const userPermissionsQuery = useUsersAuthzAPIAdminPermissionsReadGetPermissionsOfUser(user.id);

  // Create a wrapper component that includes the userId
  const UserPermissionItemWrapper = (props: PermissionItemComponentProps<UserPermissionDto>) => (
    <UserPermissionItem {...props} userId={user.id} groupId={user.groupId} />
  );

  const resetMutation = useUsersAuthzAPIAdminPermissionsWriteResetUserPermissions();

  return (
    <ActionPermissionsView
      catalog={permissionsCatalogQuery.data}
      permissions={userPermissionsQuery.data?.permissions}
      PermissionItemComponent={UserPermissionItemWrapper}
      isLoading={permissionsCatalogQuery.isLoading || userPermissionsQuery.isLoading}
      error={permissionsCatalogQuery.error || userPermissionsQuery.error}
      onReset={async () => {
        await resetMutation.mutateAsync({
          userId: user.id,
        });

        queryClient.invalidateQueries({
          queryKey: userPermissionsQuery.queryKey,
        });
      }}
    />
  );
}
